<template >
  <div>
    <div>
      <div class="formPosition">
        <v-card style="margin:auto;" width="1240">
          <v-card-title style="background-color:#006699;color:white;"></v-card-title>
          <v-progress-linear style="margin : 0 auto ; height:10px" color="green" indeterminate v-show="isLoading"></v-progress-linear>
          <v-data-table :headers="headers" :items="dados" :search="searchInDb" sort-by="data_" class="elevation-3">
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-row>
                  <v-col md="8">
                    <v-toolbar-title>Estudantes - Cadastrados</v-toolbar-title>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="3"></v-col>
                  <v-col md="3">
                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="date" label="Seleciona a data inicial" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                        <v-btn text color="primary" @click="$refs.menu.save(date)"> OK </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="3">
                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :return-value.sync="date2" transition="scale-transition" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="date2" label="Seleciona a data final" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="date2" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                        <v-btn text color="primary" @click="$refs.menu2.save(date2)"> OK </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="1">
                    <v-btn small fab color="green" @click="getEstudantes()" style="color:white;"><v-icon>search</v-icon></v-btn>
                  </v-col>
                  <v-col md="1">
                    <v-btn small fab color="primary" @click="gerarHTML()"><v-icon>print</v-icon></v-btn>
                  </v-col>
                </v-row>
              </v-toolbar>
              <div style="text-align: center;">
                <v-progress-circular :size="50" color="primary" indeterminate v-if="isLodingPDF"></v-progress-circular>
              </div>
            </template>
            
            <template v-slot:item.action="{ item }">
              <v-menu bottom origin="center center" transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab dark small color="#006699" v-bind="attrs" v-on="on">
                    <v-icon dark>menu</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="SetEditItem(item)"><v-icon color="#006699" small>edit</v-icon>Editar</v-list-item>
                  <v-list-item @click="setEliminar(item)"><v-icon color="red" small>delete</v-icon>Eliminar</v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:no-data> Clica em + para adicionar novo estudante </template>
          </v-data-table>
          <v-card-actions>
            <v-row>
              <v-col md="9"></v-col>
              <v-col md="3"><span style="font-weight:bold;">Total estudantes:</span><v-chip>{{ total }}</v-chip></v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from '../../../plugins/axios';
import utilitarios from '../../../plugins/utilitarios';
import impressaoService from '../../../services/impressaoService';
const ls = require('local-storage')
export default {
  data: () => ({
    dados: [],
    config: null,
    isLodingPDF: false,
    isLoading: false,
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    menu2: null,
    util: utilitarios,
    headers: [
      { text: 'Nome.', value: 'nome' },
      { text: 'B.I.', value: 'bi' },
      { text: 'Sexo', value: 'sexo' },
      { text: 'Matricula', value: 'matricula' },
      { text: 'Ano acadêmico', value: 'anoacademico' },
      { text: 'Registrado por', value: 'autor' },
      { text: 'Data', value: 'data_' }
    ],
    searchInDb: '',
    dialog: false,
    overlay: false,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
  }),

  computed: {
    total() {
      return this.dados.length
    }
  },

  created() {
  },

  methods: {
    async getEstudantes() {
      this.isLodingPDF = true;
      let params = {
        date1: this.date,
        date2: this.date2
      }
      try {
        this.dados = await axios.post('relatorioCadastroEstudantes', params).then((res) => res.data)
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro ao carregar os seus dados.');
      } finally {
        this.isLodingPDF = false;
      }
    },

    // Método responsavel por criar um HTML com os dados da coleção this.dados[]
    async gerarHTML() {
      this.isLodingPDF = true;
      try {
        let header = ` `;
        let dados = ``;
        let lastRow = ``;
        let i = 1;
        let periodo = ` 
            <table class="table2">
              <tr>
                <td>
                  <div class="logo">
                    <span><img class="logo_img" src=`+ ls.get('logotipo') + ` alt=""/></span>
                    <br><span>`+ ls.get('empresa').toUpperCase() + `</span>
                  </div>
                </td>
              </tr>
            </table>
            <div class="dados_academicos">
              <span>Relatório de estudantes - Cadastrados</span>
              <br><span>Gerada em: ` + this.data_hora() + `</span> 
              <br><span>Gerado por: ` + ls.get('nomeUsuario') + `</span> 
            </div>`
        header = ` 
            <th class="table_header border_on_table largura1">Ord.</th>
            <th class="table_header border_on_table largura3">Nome</th>  
            <th class="table_header border_on_table largura5">B.I.</th>  
            <th class="table_header border_on_table largura1">Sexo</th>  
            <th class="table_header border_on_table largura2">Matricula</th>
            <th class="table_header border_on_table largura1">Ano Acadêmico</th>
            <th class="table_header border_on_table largura5">registrado por</th>
            <th class="table_header border_on_table largura4">Data</th>`
        this.dados.forEach(element => {
          dados += `
            <tr>
              <td class="border_on_table largura1">` + i + `</td>
              <td class="table_data data_disciplina border_on_table largura3">` + element.nome + `</td>
              <td class="table_data border_on_table largura5">` + element.bi + `</td>
              <td class="table_data border_on_table largura1">` + element.sexo + `</td>
              <td class="table_data border_on_table largura2">` + element.matricula + `</td>
              <td class="table_data border_on_table largura1">` + element.anoacademico + `</td>
              <td class="table_data border_on_table largura5">` + element.autor + `</td>
              <td class="table_data border_on_table largura4">` + element.data_ + `</td>
            </tr>`
          i++
        })
        lastRow = `
          <tr class="border_on_table">
            <th colspan="7" style="text-align:right" bgcolor="#DCDCDC">Total estudantes:</th>
            <td style="text-align:right" bgcolor="#DCDCDC">` + (this.total) + `</td>
          </tr>`

        this.html = `
            <html>
              <head>
                <style>
                  * {
                    font-family: "Times New Roman", sans-serif;
                  }
                  .table_header {
                    padding: 5px 3px;
                    text-align: center;
                    background-color: #DCDCDC;
                  }
                  .table_data {
                    text-align: center;
                    padding: 5px;
                  }
                  tr td.data_disciplina {
                    text-align: left;
                  }
                  .logo {
                    width: 100%;
                    text-align: center;
                    margin-bottom: 10px;
                  }
                  .logo_img {
                    width:90%;
                    max-width:50px;
                  }
                  
                  .dados_academicos {
                    border-radius: 15px;
                    border: 1px solid #000000;
                    padding: 15px; 
                    font-size:10px
                  }
                  .table1 {
                    width: 100%;
                    margin-top: 30px;
                  }
                  .table2 {
                    border: 0px solid black;
                    margin-left: 0px;
                    margin-right: auto;
                    width: 100%
                  }
                  .legenda {
                    margin-top: 20px;
                    font-size: 10px;
                  }
                  .border_on_table {
                    border: 1px solid #000;
                    text-align: center;
                  }
                  table, th, td {
                    border: 0px solid black;
                    border-collapse: collapse;
                    font-size: 7px;
                  }
                  .largura1{ width: 5%; }
                  .largura2{ width: 10%; }
                  .largura3{ width: 25%; }
                  .largura4{ width: 10%; }
                  .largura5{ width: 20%; }
                  
                </style>
              </head>
              <body>
                ` + periodo + `
                <table class="table1">
                  <tr> ` + header + ` </tr>
                  <tr> ` + dados + ` </tr>
                  <tr> ` + lastRow + ` </tr>
                </table>
              </body>
            </html> `
            let options = {
          'format': 'A4',
          'border': {
            'right': '9mm',
            'left': '9mm'
          },
          'header': {
            'height': '5mm'
          },
          'footer': {
            'height': '6mm'
          }
        }
            impressaoService.htmlToPdf(this.html, options);
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro ao carregar os seus dados.');
      } finally {
        this.isLodingPDF = false;
      }
    },
    // Método responsavél por guardar a data atual
    data_hora() {
      let data = new Date()
      return data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear()) + ' ' + (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
    }
  }
}
</script>
 
<style scoped></style>
